import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

/**
 * 定义 Logo 组件
 */
class Logo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { sectionTitle, logo, sectionUrl },
        } = this.props;

        return (
            <div>
                <div className={styles.logo}>
                    <a href="//www.ifeng.com/" target="_blank">
                        <span />
                    </a>
                </div>
                <div className={styles.sub_logo}>
                    <a href={sectionUrl} target="_blank">
                        <img src={logo} alt={sectionTitle} />
                    </a>
                </div>
                <div className={styles.breadcrumbs}>
                    <a href={sectionUrl} target="_blank">
                        栏目首页
                    </a>
                    {/* {' | '}
                    <a href="//test0.web-channel-spring.shank.ifeng.com/pc/original/low" target="_blank">
                        独家汇总页
                    </a> */}
                </div>
            </div>
        );
    }
}

export default errorBoundary(Logo);
